import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-avatar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 只能上传 jpg/png 文件，且不超过 500kb ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "修改头像",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "30%",
      center: "",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          action: _ctx.action,
          name: "avatar",
          headers: _ctx.headers,
          "on-success": _ctx.handleSuccess,
          "list-type": "picture"
        }, {
          tip: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("点击上传")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "headers", "on-success"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}